import * as Subscriptions from './Subscriptions'
import * as Methods from './Methods'

export type SubscriptionRequest =
  | Subscriptions.ClientsCountSubscription
  | Subscriptions.CurrentErrorsSubscription
  | Subscriptions.CurrentWarningsSubscription
  | Subscriptions.DevicesCountSubscription
  | Subscriptions.DevicesInPowerBracketCountSubscription
  | Subscriptions.DevicesOnlineSubscription
  | Subscriptions.DevicesOnlineInSubscription
  | Subscriptions.IncomingServicesSubscription
  | Subscriptions.PerformedServicesSubscription
  | Subscriptions.LocationsCountSubscription
  | Subscriptions.VariableSpeedDevicesCountSubscription
  | Subscriptions.DeviceSensorSubscription
  | Subscriptions.DeviceOverviewSubscription
  | Subscriptions.DevicesListSubscription
  | Subscriptions.MasterDevicesListSubscription
  | Subscriptions.UsersOnlineSubscription
  | Subscriptions.UsersActiveSubscription
  | Subscriptions.PendingInvitesSubscription
  | Subscriptions.PendingMachinesSharesSubscription
  | Subscriptions.DevicesEventsSubscription

export type SubscriptionPayload =
  | Subscriptions.ClientsCount
  | Subscriptions.CurrentErrors
  | Subscriptions.CurrentWarnings
  | Subscriptions.DevicesCount
  | Subscriptions.DevicesInPowerBracketCount
  | Subscriptions.DevicesOnline
  | Subscriptions.DevicesOnlineIn
  | Subscriptions.IncomingServices
  | Subscriptions.PerformedServices
  | Subscriptions.LocationsCount
  | Subscriptions.VariableSpeedDevicesCount
  | Subscriptions.DeviceSensor
  | Subscriptions.DeviceOverview
  | Subscriptions.DevicesList
  | Subscriptions.MasterDevicesList
  | Subscriptions.UsersOnline
  | Subscriptions.UsersActive
  | Subscriptions.PendingInvites
  | Subscriptions.PendingMachinesShares
  | Subscriptions.DevicesEvents

export type SubscribtionMessage = {
  action: 'subscribe' | 'unsubscribe' //todo - move to type
  resources: SubscriptionRequest[]
}

export type SubscriptionResponse = {
  type: 'subscribedData'
  data: SubscriptionPayload[]
}

export type MethodCall =
  | Methods.SensorPlotCall
  | Methods.DeviceListCall
  | Methods.DeviceDetailsListCall
  | Methods.OrganizationsListCall
  | Methods.UsersListCall
  | Methods.DeviceInvitesListCall
  | Methods.OrganizationInvitesListCall
  | Methods.OrganizationTypeCall
  | Methods.PendingServicesListCall
  | Methods.PerformedServicesListCall
  | Methods.EventSummaryPlotCall
  | Methods.CommonEventsCall
  | Methods.DevicesOnlineInCall
  | Methods.DeviceSensorCall
  | Methods.DeviceSensorDifferenceCall
  | Methods.DeviceSensorMeanCall
  | Methods.RaportingPreferencesCall
  | Methods.NotificationPreferencesCall
  | Methods.UserDetailsCall
  | Methods.OrganizationDetailsCall
  | Methods.DeviceDetailsCall
  | Methods.AdminUsersListCall
  | Methods.AdminUserDetailsCall
  | Methods.AdminOrganizationsListCall
  | Methods.AdminOrganizationDetailsCall
  | Methods.AdminOrganizationInvitesListCall
  | Methods.AdminDeviceDetailsListCall
  | Methods.AdminDeviceDetailsCall
  | Methods.AdminDeviceInvitesListCall

export type MethodResponsePayload =
  | Methods.SensorPlot
  | Methods.DeviceList
  | Methods.DeviceDetailsList
  | Methods.OrganizationsList
  | Methods.UsersList
  | Methods.DeviceInvitesList
  | Methods.OrganizationInvitesList
  | Methods.OrganizationType
  | Methods.PendingServicesList
  | Methods.PerformedServicesList
  | Methods.EventSummaryPlot
  | Methods.CommonEvents
  | Methods.DevicesOnlineIn
  | Methods.DeviceSensor
  | Methods.DeviceSensorDifference
  | Methods.DeviceSensorMean
  | Methods.RaportingPreferences
  | Methods.NotificationPreferences
  | Methods.UserDetails
  | Methods.UserDetails
  | Methods.OrganizationDetails
  | Methods.DeviceDetails
  | Methods.AdminUsersList
  | Methods.AdminUserDetails
  | Methods.AdminOrganizationsList
  | Methods.AdminOrganizationDetails
  | Methods.AdminOrganizationInvitesList
  | Methods.AdminDeviceDetailsList
  | Methods.AdminDeviceDetails
  | Methods.AdminDeviceInvitesList

export type MethodNames = MethodCall['method']
export type MethodParams<MethodName> = Extract<MethodCall, { method: MethodName }>['params']
export type MethodResponses = {
  [key in MethodResponsePayload['method']]: Extract<MethodResponsePayload, { method: key }>
}
export type MethodResponsesData = MethodResponses[keyof MethodResponses]['data']

export type MethodCallMessage = {
  jsonrpc: '2.0'
  action: 'method'
  id: string
} & MethodCall

export type MethodResponse = {
  jsonrpc: '2.0'
  type: 'methodResult'
  id: string
} & Exclude<MethodResponsePayload, 'method'>

export type PongResponse = {
  type: 'pong'
  pingWithinSeconds: number
  sessionTtlSeconds: number
}

export type AcknowledgeSubscriptionsResponse = {
  acknowledgedSubscriptions: SubscriptionRequest[]
}

export type IncomingData = SubscriptionResponse | MethodResponse | PongResponse

export type MethodCallback = (payload: MethodResponsePayload) => void

export const PING_MESSAGE = {
  action: 'ping', // TODO - move from route to action or type
} as const

export type WebsocketOutgoingMessage = SubscribtionMessage | MethodCallMessage | typeof PING_MESSAGE
